import { MobileStepper, Stack } from "@mui/material";
import { SenecStepperButtons, StepperProps } from "src/components/navigation/stepper-buttons/SenecStepperButtons";
import { useScreenSize } from "src/hooks/useScreenSize";

export const OnboardingDialogStepper = ({ activeStep, totalSteps, setActiveStep, buttons }: StepperProps) => {
    const { isMobile } = useScreenSize();

    return (
        <Stack
            direction={isMobile ? "column" : "row"}
            alignItems={"center"}
            justifyContent={totalSteps > 1 ? "space-between" : "flex-end"}
            width={"100%"}
            spacing={isMobile ? "12px" : 0}
        >
            {totalSteps > 1 && (
                <MobileStepper
                    data-testid={"stepper-dots"}
                    variant="dots"
                    steps={totalSteps}
                    position="static"
                    activeStep={activeStep}
                    backButton={null}
                    nextButton={null}
                />
            )}
            <SenecStepperButtons
                activeStep={activeStep}
                totalSteps={totalSteps}
                setActiveStep={setActiveStep}
                buttons={buttons}
            />
        </Stack>
    );
};
